module.exports = __webpack_public_path__ + "img/galerie-11.85825293.jpg";